module.exports = __webpack_public_path__ + "static/media/thumbs-down.9d5c86c7.svg";